// Reports › Finance (M5-04; KPIS-MODE, founder-approved 2026-10-22: moved from Chart): budget vs
// actual (`/reports/finance`), money per seat (`/margins`), agent spend (`/agent-spend`,
// SPEND-KPIS), the forecast, scenarios, the headcount
// plan and exports. Each is in the Reports sidebar's FINANCE group and in ⌘K. The `finance` gate
// holds the pages' old rules (every member; the old `chart` audience); the API holds the finance
// matrix and the add-on.
import { createRoute, useRouteContext } from "@tanstack/react-router";
import { AgentSpendScreen } from "../features/finance/agent-spend-screen";
import { BudgetVsActualScreen } from "../features/finance/budget-vs-actual";
import { ExportsScreen } from "../features/finance/exports-screen";
import { ForecastScreen } from "../features/finance/forecast-screen";
import { HeadcountScreen } from "../features/finance/headcount-screen";
import { MarginsScreen } from "../features/finance/margins-screen";
import { ScenariosScreen } from "../features/finance/scenarios-screen";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { ModeGate } from "../shell/mode-gate";
import { reportsRoute } from "./c.$slug.reports";

const page = <P extends string>(path: P, Screen: typeof BudgetVsActualScreen) =>
  createRoute({
    getParentRoute: () => reportsRoute,
    path,
    validateSearch: (search: Record<string, unknown>) => validateFocusSearch(search),
    component: function FinancePage() {
      const { api } = useRouteContext({ from: "__root__" });
      return (
        <ModeGate modeKey="finance">
          <Screen api={api} company={useCompany()} />
        </ModeGate>
      );
    },
  });

export const financeBvaRoute = page("finance", BudgetVsActualScreen);
export const financeMarginsRoute = page("finance/margins", MarginsScreen);
export const financeAgentSpendRoute = page("finance/agent-spend", AgentSpendScreen);
export const financeForecastRoute = page("finance/forecast", ForecastScreen);
export const financeScenariosRoute = page("finance/scenarios", ScenariosScreen);
export const financeHeadcountRoute = page("finance/headcount", HeadcountScreen);
export const financeExportsRoute = page("finance/exports", ExportsScreen);

export const reportsFinanceRoutes = [
  financeBvaRoute,
  financeMarginsRoute,
  financeAgentSpendRoute,
  financeForecastRoute,
  financeScenariosRoute,
  financeHeadcountRoute,
  financeExportsRoute,
] as const;
